import { ValueOf } from "src/types.d"

export const ContactListCommentScreens = Object.freeze({
  ContactListCommentOverview: "ContactListCommentOverview",
  ContactSurveyCommentDetail: "ContactSurveyCommentDetail",
  ContactScheduleCommentDetail: "ContactScheduleCommentDetail",
} as const)

export type ContactListCommentScreens = ValueOf<typeof ContactListCommentScreens>
